













import { Component, Vue, Prop } from 'vue-property-decorator'
import { LimitBuyCouponRuleConfig } from './model/limitBuyCouponRuleConfig'
import CouponSelect from '@/components/coupon-select/index.vue'
import CouponTable from '../couponTable/index.vue'
import CouponDto from '../coupon/model/couponDto'

@Component({
  components: {
    CouponSelect,
    CouponTable
  }
})
export default class GrabCoupon extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        memberScope: 'All',
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: [],
        coupons: []
      }
    }
  })
  value!: LimitBuyCouponRuleConfig

  couponSelectChange(list) {
    console.log('选中的优惠券', list)
    this.value.coupons = this.value.coupons.concat(
      list.map(x => {
        let item = {
          id: x.id,
          name: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.discountValue,
          quantity: 1
        }
        return item
      })
    )
  }
}
